import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => {
  return {
    path: "lrt-dashboard",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "productRequest" */ "./LRTDashboard"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;

          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
  };
};
